import { IFilterButtonGroupItemsWithBtnText } from '@/bundles/GroupFilters/interfaces/inputs/IFilterButtonGroupItems';
import { AllExcludeOnlyEnum, AllExcludeOnlyLabels } from '@/bundles/GroupFilters/enums/AllExcludeOnlyEnum';

export const FilterPocketListingButtonItems: IFilterButtonGroupItemsWithBtnText[] = [
  {
    text: AllExcludeOnlyLabels[AllExcludeOnlyEnum.only],
    value: AllExcludeOnlyEnum.only,
    btnText: `Pocket Only`,
  },
  {
    text: AllExcludeOnlyLabels[AllExcludeOnlyEnum.all],
    value: AllExcludeOnlyEnum.all,
  },
  {
    text: AllExcludeOnlyLabels[AllExcludeOnlyEnum.exclude],
    value: AllExcludeOnlyEnum.exclude,
    btnText: `Exclude Pocket`,
  }
];
